import { render, staticRenderFns } from "./DefinitionDetails.vue?vue&type=template&id=3c69b86b&scoped=true"
import script from "./DefinitionDetails.vue?vue&type=script&lang=js"
export * from "./DefinitionDetails.vue?vue&type=script&lang=js"
import style0 from "./DefinitionDetails.vue?vue&type=style&index=0&id=3c69b86b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c69b86b",
  null
  
)

export default component.exports